import { apiJson, replaceUserEndpoint } from './userEndpoint';

export function fetchCommunityChallenges({ userId, endpoint, csrfToken, status }) {
	const base = replaceUserEndpoint(endpoint, { userId });
	const url = status ? `${base}?status=${encodeURIComponent(status)}` : base;
	return apiJson(url, { csrfToken }).then((r) => r.data || []);
}

export function fetchCommunityChallenge({ userId, challengeId, endpoint, csrfToken }) {
	const url = replaceUserEndpoint(endpoint, { userId, id: challengeId });
	return apiJson(url, { csrfToken }).then((r) => r.data);
}

export function fetchCommunityEligibleProfiles({ userId, endpoint, csrfToken }) {
	const url = replaceUserEndpoint(endpoint, { userId });
	return apiJson(url, { csrfToken }).then((r) => r.data);
}

export function fetchCommunityTemplates({ userId, endpoint, csrfToken }) {
	const url = replaceUserEndpoint(endpoint, { userId });
	return apiJson(url, { csrfToken }).then((r) => ({
		templates: r.data?.templates || [],
		wizard: r.data?.wizard || null
	}));
}

export function createCommunityChallenge({ userId, endpoint, csrfToken, payload }) {
	const url = replaceUserEndpoint(endpoint, { userId });
	return apiJson(url, {
		method: 'POST',
		csrfToken,
		body: payload
	}).then((r) => r.data);
}

export function joinCommunityChallenge({ userId, challengeId, endpoint, csrfToken, fitnessProfileId }) {
	const url = replaceUserEndpoint(endpoint, { userId, id: challengeId });
	return apiJson(url, {
		method: 'POST',
		csrfToken,
		body: { fitness_profile_id: fitnessProfileId }
	}).then((r) => r.data);
}

export function submitCommunityResult({
	userId,
	challengeId,
	participationId,
	endpoint,
	csrfToken,
	resultValue,
	note
}) {
	const url = replaceUserEndpoint(endpoint, {
		userId,
		id: challengeId,
		participationId
	});
	return apiJson(url, {
		method: 'PATCH',
		csrfToken,
		body: { result_value: resultValue, note }
	}).then((r) => r.data);
}

export function cancelCommunityChallenge({ userId, challengeId, endpoint, csrfToken }) {
	const url = replaceUserEndpoint(endpoint, { userId, id: challengeId });
	return apiJson(url, { method: 'PATCH', csrfToken }).then((r) => r.data);
}
